import { render } from "./slideMenu.vue?vue&type=template&id=2c22a5f2&scoped=true"
import script from "./slideMenu.vue?vue&type=script&lang=js"
export * from "./slideMenu.vue?vue&type=script&lang=js"

import "./slideMenu.vue?vue&type=style&index=0&id=2c22a5f2&scoped=true&lang=css"

import exportComponent from "D:\\PDM-小程序\\HSM_PDM\\PDM_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c22a5f2"]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList});
